import reqNotaFiscal from "../../../services/reqCobranca/reqNotaFiscal";
import reqFiscalConfig from "../../../services/reqCobranca/reqFiscalConfig";
import reqFechamentoFiscal from "../../../services/reqEMail/reqFechamentoFiscal";
import LibDateTime from "../../../util/libDateTime";
import { formatarCpfCnpj } from "../../../util/documento";
import { mensagemDeErro } from "../hooks";
import { STATUS } from "../status";

const COM_ERRO = ["REJEITADA", "ERRO", "CONT_REJEITADA"];
const EM_ABERTO = ["EM_MONTAGEM", "GERADA", "CONTINGENCIA", "AGUARDANDO_ENVIO", "PENDENTE"];

function somar(status, tipos, campo = "qtd") {
	return status.filter((s) => tipos.includes(s.status)).reduce((total, s) => total + s[campo], 0);
}

function notaDe(nota) {
	return {
		serie: nota.serie,
		numero: nota.numero,
		emissao: LibDateTime.parseDelphiLocal(nota.data_emissao, "dd/MM/yyyy HH:mm"),
		chave: nota.chave,
		cliente: nota.dest_nome || formatarCpfCnpj(nota.dest_cpfcnpj) || "Consumidor final",
		situacao: STATUS[nota.status].rotulo,
		autorizada: nota.status === "AUTORIZADA",
		valor: nota.valor_total,
	};
}

function resumoDe({ status, cfops, lacunas, notas }) {
	return {
		emitidas: somar(status, ["AUTORIZADA"]),
		canceladas: somar(status, ["CANCELADA"]),
		denegadas: somar(status, ["DENEGADA"]),
		inutilizadas: somar(status, ["INUTILIZADA"]),
		rejeitadas: somar(status, COM_ERRO),
		pendentes: somar(status, EM_ABERTO),
		valorAutorizado: somar(status, ["AUTORIZADA"], "valor"),
		cfops,
		lacunas,
		notas: notas.map(notaDe),
	};
}

export function enviosDoModelo(envios, modelo) {
	return envios.filter((envio) => envio.modelo === modelo);
}

export async function carregarFechamento(ano, mes) {
	const [fechamento, config, envios] = await Promise.all([
		reqNotaFiscal.fechamento({ ano, mes }),
		reqFiscalConfig.get().catch(() => ({ data: {} })),
		reqFechamentoFiscal
			.listar({ ano, mes })
			.then((resposta) => ({ lista: resposta.data, falha: null }))
			.catch((erro) => ({ lista: [], falha: mensagemDeErro(erro) })),
	]);

	return {
		nfe: resumoDe(fechamento.data.nfe),
		nfce: resumoDe(fechamento.data.nfce),
		empresa: config.data || {},
		envios: { nfe: enviosDoModelo(envios.lista, 55), nfce: enviosDoModelo(envios.lista, 65) },
		falhaEnvios: envios.falha,
	};
}
